export const langObject = {
    "en": { "EnterCharacters": "Please enter the characters that appear below", "submit": "Submit", "enterprompt": "Enter characters here...", "title": "Human Verification", "loading": "Loading the form. We'll be just a moment.", "invalid": "Invalid CAPTCHA" },
    "es": { "EnterCharacters": "Por favor, introduzca los caracteres que aparecen a continuación", "submit": "Enviar", "enterprompt": "Introduzca los caracteres aquí...", "title": "Verificación humana", "loading": "Cargando el formulario. Estaremos en un momento.", "invalid": "CAPTCHA no válido" },
    "cn": { "EnterCharacters": "请输入下面出现的字符", "submit": "提交", "enterprompt": "在此输入字符...", "title": "人类验证", "loading": "加载表格 我们马上就好", "invalid": "验证码无效" }
};




export const CheckLanguage = (dbFormSpec) => {
    if (dbFormSpec) {
        if (dbFormSpec.languageOverride) {
            return dbFormSpec.languageOverride;
        }
        else if (dbFormSpec.context) {
            if (dbFormSpec.context.languageOverride) {
                return dbFormSpec.context.languageOverride;
            }
        }
    }
    return "default";

};

export const GetLanguageText = (languageID) => {

    const validLanguageIDs = ["en", "es", "cn"];

    if (validLanguageIDs.includes(languageID)) {
        let returnLang = langObject[languageID];
        if (returnLang) {
            return returnLang; //only return valid dictionary
        }
    }

    return langObject["en"];  // default to ENglish
}
